export default __webpack_public_path__ + "static/media/Udemy-marketing-in-messenger.adc3a761.webp";